module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (106).d4c779e0.jpg";